/* action types */
export const REQUEST_PROGRAM_MEMBERSHIP_DETAILS = 'REQUEST_PROGRAM_MEMBERSHIP_DETAILS';
export const RECEIVE_PROGRAM_MEMBERSHIP_DETAILS = 'RECEIVE_PROGRAM_MEMBERSHIP_DETAILS';
export const REQUEST_PROGRAM_MEMBERSHIP_DETAILS_ERROR = 'REQUEST_PROGRAM_MEMBERSHIP_DETAILS_ERROR';
export const REQUEST_STUDENT_STATUS = 'REQUEST_STUDENT_STATUS';
export const RECEIVE_STUDENT_STATUS = 'RECEIVE_STUDENT_STATUS';
export const REQUEST_STUDENT_STATUS_ERROR = 'REQUEST_STUDENT_STATUS_ERROR';
